export default function redirectMiddleware(history) {
  return ({dispatch, getState}) => next => action => {
    if (action.type === 'REDIRECT_TO') {
      const params = action.data.params || {}
      const forced = action.data.forced || false;
      const locale = action.data.locale ? getState().intl.locale : null;
      const composeURL = locale ?
      (locale + action.data.url)
      :
      (action.data.url)

      if ((history.location.pathname !== composeURL) || forced) {
        Promise
          .resolve(history.push(composeURL, {...params}))
          .then(() => {
            action.data.action
              ? dispatch(action.data.action)
              : console.info(`Resolved in path ${composeURL}`)
          })
          .catch((error) => console.log(error));
      }
    }

    return next(action);
  }
}
